import {
  Appointment,
  AppointmentParticipant,
  AppointmentParticipantType,
} from '@generated/gql/graphql';

const getParticipantByType = (
  appointment: Nullable<Appointment>,
  participantType: AppointmentParticipantType
) => {
  if (!appointment) return null;

  return (
    appointment.participants.find(({ type }) => type === participantType) ??
    null
  );
};

const getParticipantLabel = (type: AppointmentParticipantType): string => {
  switch (type) {
    case AppointmentParticipantType.Partner:
      return 'Lead Partner';
    case AppointmentParticipantType.SupportingPartner:
      return 'Supporting Partner';
    case AppointmentParticipantType.Customer:
      return 'Customer';
    default:
      return '';
  }
};

const getCurrentParticipantsSuffix = (
  participants: AppointmentParticipant[]
): string => {
  if (participants.length === 0) return '';

  const formatted = participants.map((p) => {
    const label = getParticipantLabel(p.type);
    return label ? `${p.name} (${label})` : p.name;
  });

  const verb = participants.length === 1 ? 'is' : 'are';

  if (formatted.length === 1) {
    return `. Currently only ${formatted[0]} ${verb} in the appointment`;
  }

  const last = formatted[formatted.length - 1];
  const rest = formatted.slice(0, -1);
  return `. Currently only ${rest.join(', ')} and ${last} ${verb} in the appointment`;
};

export {
  getParticipantByType,
  getParticipantLabel,
  getCurrentParticipantsSuffix,
};
